import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { Action, Dispatch } from "redux";
import { FrontDate } from "../../domain/model/frontDate";
import {
  Source,
  TRegisterClientRequest,
} from "../../domain/repository/apply_client_repository";
import { TCreateCustomerRequest } from "../../domain/repository/customer_repository";
import { entity } from "../../infra/api/rpc/api";
import { createAuthActionCreator } from "../action/auth_action";
import AuthComponent from "../component/auth/auth";
import {
  IAuthDispatcher,
  createAuthDispatcher,
} from "../dispatcher/auth_dispatcher";
import {
  ApplyClientRequest,
  CreateCustomerRequest,
  LoginRequest,
} from "../request/auth_request";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";

// facebook pixel code 型定義
declare var fbq: any;

interface IProps extends RouteComponentProps<{}> {
  state: AuthState;
  dispatcher: IAuthDispatcher;
}

interface IState {}

export class Auth extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  public componentDidMount() {
    // facebook pixel code 通常イベント コンテンツを表示
    if (this.props.location.pathname === "/customer/_create") {
      fbq("track", "ViewContent");
    }
  }

  public render(): JSX.Element {
    const { location } = this.props;

    return (
      <AuthComponent
        location={location}
        logoutDispatcher={this.props.dispatcher.logout}
        handleCallLogin={this.callLogin}
        handleCallCreate={this.callCreate}
        handleCallSuperEngineerCreate={this.callSuperEngineerCreate}
        handleCallProCreate={this.callProCreate}
        handleApplyClient={this.handleApplyClient}
        handleApplyClientForDemo={this.handleApplyClientForDemo}
        handleApplyClientByLafool={this.handleApplyClientByLafool}
        handleApplyClientByLafoolMedical={this.handleApplyClientByLafoolMedical}
      />
    );
  }

  private callCreate = (values: any): void => {
    const params = new URLSearchParams(this.props.location.search);

    // facebook pixel code 通常イベント 登録の完了
    fbq("track", "CompleteRegistration");

    const createCustomerRequest: TCreateCustomerRequest = {
      name: values.name,
      nameKana: values.nameKana,
      gender: Number(values.gender),
      phoneNumber: values.phoneNumber,
      birthdate: values.birthdate,
      portfolio: "",
      type: entity.Customer.Type.Type_Expert,
      campaign: entity.Customer.Campaign.Campaign_Normal,
      routeInfo: params.get("route_info") || "",
      facebookURL: values.facebookURL || "",
    };

    const req: CreateCustomerRequest = new CreateCustomerRequest();
    req.createCustomerRequest = createCustomerRequest;
    req.email = values.email;
    req.password = values.password;

    this.props.dispatcher.createCustomer(req);
  };

  private callSuperEngineerCreate = (values: any): void => {
    const params = new URLSearchParams(this.props.location.search);

    // facebook pixel code 通常イベント 登録の完了
    fbq("track", "CompleteRegistration");

    const createCustomerRequest: TCreateCustomerRequest = {
      name: values.name,
      nameKana: values.nameKana,
      gender: Number(values.gender),
      phoneNumber: values.phoneNumber,
      birthdate: FrontDate.fromEmpty(),
      portfolio: values.portfolio,
      type: entity.Customer.Type.Type_Expert,
      campaign: entity.Customer.Campaign.Campaign_SuperEngineer,
      routeInfo: params.get("route_info") || "",
      facebookURL: "",
    };

    const req: CreateCustomerRequest = new CreateCustomerRequest();
    req.createCustomerRequest = createCustomerRequest;
    req.email = values.email;
    req.password = values.password;

    this.props.dispatcher.createCustomer(req);
  };

  private callProCreate = (values: any): void => {
    const params = new URLSearchParams(this.props.location.search);

    const createCustomerRequest: TCreateCustomerRequest = {
      name: values.name,
      nameKana: values.nameKana,
      gender: Number(values.gender),
      phoneNumber: values.phoneNumber,
      birthdate: FrontDate.fromEmpty(),
      portfolio: values.portfolio,
      type: entity.Customer.Type.Type_Pro,
      campaign: entity.Customer.Campaign.Campaign_Normal,
      routeInfo: params.get("route_info") || "",
      facebookURL: "",
    };

    const req: CreateCustomerRequest = new CreateCustomerRequest();
    req.createCustomerRequest = createCustomerRequest;
    req.email = values.email;
    req.password = values.password;

    this.props.dispatcher.createCustomer(req);
  };

  private callLogin = (values: any): void => {
    const res: LoginRequest = new LoginRequest();
    res.email = values.username;
    res.password = values.password;
    this.props.dispatcher.login(res);
  };

  private handleApplyClient = (values: any): void => {
    const params = new URLSearchParams(this.props.location.search);

    const registerClientRequest: TRegisterClientRequest = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      companyName: values.companyName,
      webURL: values.webURL,
      accountName: values.accountName,
      accountNameKana: values.accountNameKana,
      department: values.department,
      position: values.position,
      source: Source.Source_Internal,
      isDemo: false,
      demoPassword: "",
      routeInfo: params.get("route_info") || "",
    };

    const res: ApplyClientRequest = new ApplyClientRequest();
    res.registerClientRequest = registerClientRequest;
    this.props.dispatcher.applyClient(res);
  };

  private handleApplyClientForDemo = (values: any): void => {
    const params = new URLSearchParams(this.props.location.search);

    const registerClientRequest: TRegisterClientRequest = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      companyName: values.companyName,
      webURL: values.webURL,
      accountName: values.accountName,
      accountNameKana: values.accountNameKana,
      department: "",
      position: "",
      source: Source.Source_Internal,
      isDemo: true,
      demoPassword: values.password,
      routeInfo: params.get("route_info") || "",
    };

    const res: ApplyClientRequest = new ApplyClientRequest();
    res.registerClientRequest = registerClientRequest;
    this.props.dispatcher.applyClient(res);
  };

  private handleApplyClientByLafool = (values: any): void => {
    const registerClientRequest: TRegisterClientRequest = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      companyName: values.companyName,
      webURL: values.webURL,
      accountName: values.accountName,
      accountNameKana: values.accountNameKana,
      department: values.department,
      position: values.position,
      source: Source.Source_Lafool,
      isDemo: false,
      demoPassword: "",
      routeInfo: "",
    };

    const res: ApplyClientRequest = new ApplyClientRequest();
    res.registerClientRequest = registerClientRequest;
    this.props.dispatcher.applyClient(res);
  };

  private handleApplyClientByLafoolMedical = (values: any): void => {
    const registerClientRequest: TRegisterClientRequest = {
      email: values.email,
      phoneNumber: values.phoneNumber,
      companyName: values.companyName,
      webURL: values.webURL,
      accountName: values.accountName,
      accountNameKana: values.accountNameKana,
      department: values.department,
      position: values.position,
      source: Source.Source_LafoolMedical,
      isDemo: false,
      demoPassword: "",
      routeInfo: "",
    };

    const res: ApplyClientRequest = new ApplyClientRequest();
    res.registerClientRequest = registerClientRequest;
    this.props.dispatcher.applyClient(res);
  };
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.authReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createAuthDispatcher(dispatch, createAuthActionCreator()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Auth);



// WEBPACK FOOTER //
// ./src/presentation/container/auth_container.tsx